import { useEffect, useState } from 'react';
import { ListRulesResponse } from '../api/models';
import { notification } from 'antd';
import APIClient from '../api/api';
import { Column, DataTable, Num } from '../components/ui';
import { PageHead, PageToolbar } from '../layout';

const ListRules = () => {
  const [rules, setRules] = useState<ListRulesResponse>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadRules();
  }, []);

  async function loadRules() {
    setLoading(true);
    try {
      const resp = await APIClient.listRules();
      setRules(resp);
    } catch (e) {
      console.error(e);
      notification.error({ message: 'Failed to load rules at this time.' });
    } finally {
      setLoading(false);
    }
  }

  const columns: Column<ListRulesResponse['rules'][number]>[] = [
    {
      key: 'name',
      title: 'Name',
      render: (r) => <span className="text-text font-medium text-[12.5px]">{r.name}</span>,
    },
    {
      key: 'totalDomains',
      title: 'Total Domains',
      align: 'right',
      render: (r) => <Num value={r.totalDomains ?? null} format="int" />,
    },
  ];

  return (
    <>
      <PageHead title="Active Rules" subtitle="Auto-picking rules currently in effect." />
      <PageToolbar>
        <span className="ml-auto text-[11px] text-text-3 font-mono">
          {rules ? (
            <>
              total <b className="text-text-2">{rules.rules.length.toLocaleString()}</b>
            </>
          ) : (
            'loading…'
          )}
        </span>
      </PageToolbar>
      <DataTable
        columns={columns}
        data={rules?.rules ?? []}
        rowKey={(r) => String(r.id)}
        loading={loading}
        emptyMessage="No rules defined."
      />
    </>
  );
};

export default ListRules;
